import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { FormAuthenticationmessage } from "./FormAuthenticationmessage";
import "./contact.css";
import axios from "axios";
import { animateScroll as scroll } from "react-scroll";
import Swal from "sweetalert2";

export const ContactSection3 = () => {
  const handleLinkClick = () => {
    scroll.scrollToTop();
  };
  const checkboxesdata = [
    { label: "Babies' Apparel ", value: "babiesApparel" },
    { label: "Bedding ", value: "bedding" },
    { label: "Carried Accessories ", value: "carriedAccessories" },
    { label: "Children's Apparel ", value: "childrensApparel" },
    { label: "Children's Denim Apparel ", value: "childrensDenimApparel" },
    { label: "Dyed Fabrics ", value: "dyedFabrics" },
    { label: "Dyed Fibers ", value: "dyedFibers" },
    { label: "Dyed Yarns ", value: "dyedYarns" },
    { label: "Fabrics ", value: "fabrics" },
    { label: "Filling-Stuffing ", value: "fillingStuffing" },
    { label: "Footwear ", value: "footwear" },
    { label: "Functional Accessories ", value: "functionalAccessories" },
    { label: "Greige Fabrics ", value: "greigeFabrics" },
    { label: "Greige Yarns ", value: "greigeYarns" },
    { label: "Hard Goods ", value: "hardGoods" },
    { label: "Home Textiles ", value: "homeTextiles" },
    { label: "Industrial or Technical ", value: "industrialTechnical" },
    { label: "Medical ", value: "medical" },
    { label: "Men's Apparel ", value: "mensApparel" },
    { label: "Men's Denim Apparel ", value: "mensDenimApparel" },
    { label: "Other ", value: "other" },
    { label: "Outdoor ", value: "outdoor" },
    { label: "Packaging ", value: "packaging" },
    { label: "Paper Products ", value: "paperProducts" },
    { label: "Personal Care, Hygiene ", value: "personalCareHygiene" },
    { label: "Printed Fabrics ", value: "printedFabrics" },
    {
      label: "Processed Post-Consumer Materials ",
      value: "processedPostConsumerMaterials",
    },
    {
      label: "Processed Pre-Consumer Materials ",
      value: "processedPreConsumerMaterials",
    },
    {
      label: "Reclaimed Post-Consumer Materials ",
      value: "reclaimedPostConsumerMaterials",
    },
    {
      label: "Reclaimed Pre-Consumer Materials ",
      value: "reclaimedPreConsumerMaterials",
    },
    { label: "Toys ", value: "toys" },
    { label: "Tops ", value: "tops" },
    { label: "Undyed Fabrics ", value: "undyedFabrics" },
    { label: "Undyed Fibers ", value: "undyedFibers" },
    { label: "Undyed Yarns ", value: "undyedYarns" },
    { label: "Unisex Apparel ", value: "unisexApparel" },
    { label: "Unisex Denim Apparel ", value: "unisexDenimApparel" },
    {
      label: "Unprocessed Post-Consumer Fibers/Materials ",
      value: "unprocessedPostConsumerFibersMaterials",
    },
    {
      label: "Unprocessed Pre-Consumer Fibers/Materials ",
      value: "unprocessedPreConsumerFibersMaterials",
    },
    { label: "Women's Apparel ", value: "womensApparel" },
    { label: "Women's Denim Apparel ", value: "womensDenimApparel" },
    { label: "Worn Accessories ", value: "wornAccessories" },
  ];
  const countryOptions = [
    "Russia",
    "Canada",
    "China",
    "United States",
    "Brazil",
    "Australia",
    "India",
    "Argentina",
    "Kazakhstan",
    "Algeria",
    "Democratic Republic of the Congo",
    "Greenland",
    "Saudi Arabia",
    "Mexico",
    "Indonesia",
    "Sudan",
    "Libya",
    "Iran",
    "Mongolia",
    "Peru",
    "Chad",
    "Niger",
    "Angola",
    "Mali",
    "South Africa",
    "Colombia",
    "Ethiopia",
    "Bolivia",
    "Mauritania",
    "Egypt",
    "Tanzania",
    "Nigeria",
    "Venezuela",
    "Pakistan",
    "Namibia",
    "Mozambique",
    "Zambia",
    "Burma (Myanmar)",
    "Afghanistan",
    "France",
    "Somalia",
    "Central African Republic",
    "Ukraine",
    "Madagascar",
    "Botswana",
    "Kenya",
    "Yemen",
    "Thailand",
    "Turkey",
    "Cameroon",
  ];
  // You can use the 'checkboxOptions' array in your code for checkboxes as needed.

  const checkboxValidationSchema = Yup.array()
    .min(1, "Select at least one option")
    .required("Select at least one option");

  const validate = Yup.object({
    companyName: Yup.string().required("Company name is Required"),
    address: Yup.string().required("Address is Required"),
    zip: Yup.string().required("Zip code is Required"),
    city: Yup.string().required("City is Required"),
    state: Yup.string().required("State/Province is Required"),
    country: Yup.string().required("Country is Required"),
    title: Yup.string().required("Title is Required"),
    firstName: Yup.string().required("First Name is Required"),
    lastName: Yup.string().required("Last Name is Required"),
    jobTitle: Yup.string().required("Job Title is Required"),
    telephoneNumber: Yup.string().required("Telephone Number is Required"),
    emailAddress: Yup.string().email("Invalid email address"),
    acceptPolices: Yup.boolean().oneOf([true], "Accept Policies is required"),
  });

  return (
    <Formik
      initialValues={{
        companyName: "",
        address: "",
        zip: "",
        city: "",
        state: "",
        country: "",
        title: "",
        firstName: "",
        lastName: "",
        jobTitle: "",
        telephoneNumber: "",
        emailAddress: "",
        checkboxes: [],
        certificationbody: "",
        certifiedTimes: "",
        question1: "",
        question2: "",
        question3: "",
        question4: "",
        question5: "",
        selectedCountry: "",
        acceptPolices: false,
      }}
      validationSchema={validate}
      validateOnBlur={true}
      validateOnChange={true}
      onSubmit={async (values, { resetForm }) => {
        try {
          Swal.fire({
            title: "Sending Data",
            text: "Please wait...",
            icon: "info",
            allowOutsideClick: false,
            showConfirmButton: false,
            showCancelButton: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          await validate.validate(values, { abortEarly: false }); // Run validation for all fields

          // If the form is valid, proceed with submitting the data
          resetForm();
          await axios.post(
            "https://api.mbasolutions.co/certifications",
            values,
          );

          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Data has been sent successfully",
          });
        } catch (error) {
          console.error(error);

          // If the form is not valid, show an alert error
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Network Error.Please Try Again Later.",
          });
        }
      }}
    >
      {(formik) => (
        <div className="w-[92%] md:w-[88%] lg:w-[84%] mx-auto overflow-x-hidden">
          <div className="bg-white rounded-3xl shadow-xl border border-[#f2d7b8] px-4 md:px-10 lg:px-12 py-10 md:py-12">
            <h1 className="w-fit px-5 md:px-10 mx-auto py-4 text-center bg-[#fff8f0] rounded-xl text-[#1B1C19] shadow-md font-bold text-lg md:text-2xl">
              Your Process for Certification Starts Here!
            </h1>
            <p className="text-center text-[#4c4d56] mt-4 mb-8 max-w-3xl mx-auto">
              Fill out the details below and our team will guide you through the
              next steps.
            </p>

            <Form className="text-[#4c4d56]">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="text-[#4c4d56]" htmlFor="companyName">
                    Name of Your Company*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="companyName"
                    name="companyName"
                    className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    placeholder="Name"
                  />
                </div>
                <div>
                  <label className="text-[#4c4d56]" htmlFor="address">
                    Address*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="address"
                    name="address"
                    className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    placeholder="Address"
                  />
                </div>
                <div>
                  <label className="text-[#4c4d56]" htmlFor="zip">
                    ZIP*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="zip"
                    name="zip"
                    className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    placeholder="ZIP"
                  />
                </div>
                <div>
                  <label className="text-[#4c4d56]" htmlFor="city">
                    City*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="city"
                    name="city"
                    className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    placeholder="City"
                  />
                </div>
                <div>
                  <label className="text-[#4c4d56]" htmlFor="state">
                    State/Province*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="state"
                    name="state"
                    className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    placeholder="State/Province"
                  />
                </div>
                <div>
                  <label className="text-[#4c4d56]" htmlFor="country">
                    Country*
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="country"
                    name="country"
                    className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    placeholder="Country"
                  />
                </div>
              </div>

              <div className="mt-8 p-4 md:p-6 bg-[#fffaf4] rounded-2xl border border-[#f7e4cc]">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="title">
                      Title*
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="title"
                      name="title"
                      placeholder="Title"
                      className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    />
                  </div>
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="firstName">
                      First Name*
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="firstName"
                      placeholder="First Name"
                      name="firstName"
                      className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    />
                  </div>
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="lastName">
                      Last Name*
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="lastName"
                      name="lastName"
                      placeholder="Last Name"
                      className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    />
                  </div>
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="jobTitle">
                      Job Title*
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="jobTitle"
                      name="jobTitle"
                      placeholder="Job Title"
                      className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    />
                  </div>
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="telephoneNumber">
                      Telephone Number*
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="telephoneNumber"
                      placeholder="Telephone Number"
                      name="telephoneNumber"
                      className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    />
                  </div>
                  <div>
                    <label className="text-[#4c4d56]" htmlFor="emailAddress">
                      Email
                    </label>
                    <FormAuthenticationmessage
                      type="text"
                      id="emailAddress"
                      placeholder="Email"
                      name="emailAddress"
                      className="py-3 border text-[#415674] text-[13px] w-full border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                    />
                  </div>
                </div>
              </div>

              {/* <h2 className="mt-10 w-fit px-4 md:px-8 mx-auto py-3 text-center shadow-md bg-white rounded-lg font-bold text-base md:text-xl text-[#1B1C19]">
                What type(s) of products would you like to have certified?
              </h2>

              <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 text-[14px] gap-y-2">
                {checkboxesdata.map((option) => (
                  <label
                    key={option.value}
                    className="flex items-start gap-2 p-2 rounded-md hover:bg-orange-50 transition-colors duration-200"
                  >
                    <input
                      type="checkbox"
                      id={`checkbox-${option.value}`}
                      name="checkboxes"
                      value={option.value}
                      className="mt-1"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.checkboxes.includes(option.value)}
                    />
                    <span>{option.label}</span>
                  </label>
                ))}
              </div>

              <h2 className="mt-10 w-fit px-4 md:px-8 mx-auto py-3 text-center shadow-md bg-white rounded-lg font-bold text-base md:text-xl text-[#1B1C19]">
                Almost Done! A Few More Questions
              </h2>

              <p className="font-light text-[14px] text-gray-500 pb-2 pt-8">
                Please describe your current certification status:
              </p>
              <div>
                <label
                  htmlFor="certifiedTimes1"
                  className="flex items-center my-3 gap-2"
                >
                  <FormAuthenticationmessage
                    type="radio"
                    id="certifiedTimes1"
                    name="certifiedTimes"
                    value="First"
                  />
                  This Is Our First Application
                </label>
                <label
                  htmlFor="certifiedTimes2"
                  className="flex items-center mb-5 gap-2"
                >
                  <FormAuthenticationmessage
                    type="radio"
                    id="certifiedTimes2"
                    name="certifiedTimes"
                    value="Other_Company"
                  />
                  Our Company Has Already Been Certified by Another Party
                </label>

                <div>
                  <label className="text-[#4c4d56]" htmlFor="certificationbody">
                    Name of the Previous Certification Body
                  </label>
                  <FormAuthenticationmessage
                    type="text"
                    id="certificationbody"
                    name="certificationbody"
                    className="py-3 border text-[#415674] text-[13px] w-full md:w-[60%] border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                  />
                </div>
              </div>

              <div className="mt-6 space-y-5">
                <div>
                  <label className="text-[#4c4d56] block">
                    Has your certificate been suspended/withdrawn before?
                  </label>
                  <div className="flex items-center gap-6 py-2">
                    <label className="flex items-center gap-2">
                      <FormAuthenticationmessage
                        type="radio"
                        name="question1"
                        value="Yes"
                      />
                      Yes
                    </label>
                    <label className="flex items-center gap-2">
                      <FormAuthenticationmessage
                        type="radio"
                        name="question1"
                        value="No"
                      />
                      No
                    </label>
                  </div>
                </div>

                <div>
                  <label className="text-[#4c4d56] block">
                    Would you like to transfer your registration to Control
                    Union?
                  </label>
                  <div className="flex items-center gap-6 py-2">
                    <label className="flex items-center gap-2">
                      <FormAuthenticationmessage
                        type="radio"
                        name="question2"
                        value="Yes"
                      />
                      Yes
                    </label>
                    <label className="flex items-center gap-2">
                      <FormAuthenticationmessage
                        type="radio"
                        name="question2"
                        value="No"
                      />
                      No
                    </label>
                  </div>
                </div>

                <div>
                  <label className="text-[#4c4d56] block">
                    Has another Certification Body denied certification before?
                  </label>
                  <div className="flex items-center gap-6 py-2">
                    <label className="flex items-center gap-2">
                      <FormAuthenticationmessage
                        type="radio"
                        name="question3"
                        value="Yes"
                      />
                      Yes
                    </label>
                    <label className="flex items-center gap-2">
                      <FormAuthenticationmessage
                        type="radio"
                        name="question3"
                        value="No"
                      />
                      No
                    </label>
                  </div>
                </div>

                <div>
                  <label className="text-[#4c4d56] block">
                    Are you already a Control Union certified client
                    (re-certification)?
                  </label>
                  <div className="flex items-center gap-6 py-2">
                    <label className="flex items-center gap-2">
                      <FormAuthenticationmessage
                        type="radio"
                        name="question4"
                        value="Yes"
                      />
                      Yes
                    </label>
                    <label className="flex items-center gap-2">
                      <FormAuthenticationmessage
                        type="radio"
                        name="question4"
                        value="No"
                      />
                      No
                    </label>
                  </div>
                </div>

                <div>
                  <label className="text-[#4c4d56] block">
                    Are you a member of any of the founding organizations of
                    GOTS?
                  </label>
                  <div className="flex items-center gap-6 py-2">
                    <label className="flex items-center gap-2">
                      <FormAuthenticationmessage
                        type="radio"
                        name="question5"
                        value="Yes"
                      />
                      Yes
                    </label>
                    <label className="flex items-center gap-2">
                      <FormAuthenticationmessage
                        type="radio"
                        name="question5"
                        value="No"
                      />
                      No
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt-6">
                <label className="text-[#4c4d56] block">
                  Which Control Union office would be your preferred partner?
                </label>
                <FormAuthenticationmessage
                  as="select"
                  name="selectedCountry"
                  className="py-3 border text-[#415674] text-[13px] w-full md:w-[60%] border-slate-300 my-2 rounded-md outline-orange-400 px-3"
                >
                  <option value="" disabled>
                    Select a country
                  </option>
                  {countryOptions.map((country, index) => (
                    <option key={index} value={country}>
                      {country}
                    </option>
                  ))}
                </FormAuthenticationmessage>
              </div>

              <div className="mt-8 flex items-center gap-3">
                <FormAuthenticationmessage
                  type="checkbox"
                  name="acceptPolices"
                  className="w-5 h-5"
                  label="I accept the validity and authenticity of the information provided in this application form."
                  checked={formik.values.acceptPolices}
                />
              </div>

              <div className="mt-10 flex flex-wrap gap-3">
                <button
                  type="submit"
                  className="btn bg-orange-500 hover:shadow-xl transition-all duration-200 ease-out text-white cursor-pointer px-6 md:px-8 py-2 rounded-md text-lg hover:bg-orange-600"
                >
                  Submit
                </button>
                <button
                  className="btn hover:shadow-xl bg-gray-500 transition-all duration-200 ease-out text-white cursor-pointer px-6 md:px-8 py-2 rounded-md text-lg"
                  type="reset"
                  onClick={handleLinkClick}
                >
                  Reset
                </button>
              </div> */}
            </Form>
          </div>
        </div>
      )}
    </Formik>
  );
};
